export default {
  downtimeUrl: "https://it.kodland.tech",
  startPage: {
    title: "Compila questo breve sondaggio, in regalo una lezione gratuita dai nostri tutor",
    subtitle:
      "Hai due minuti a disposizione? Siamo a pochi passi dall’imparare come programmare videogames, apps e siti web meravigliosi!",
    button: "Andiamo 🚀",
  },
  successPage: {
    title:
      "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione. Affrettatevi a confermare la vostra presenza per una lezione con un tutor altamente qualificato 🚀",
    subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
    button: "📆 Prenota una lezione",
  },
  quizRotateBySteps: {
    1: {
      question: "Vorresti che il tempo che tuo figlio trascorre al computer sia più produttivo?",
      answers: ["Sì!", "No. È solo per divertimento va bene così"],
    },
    2: {
      question: "Qual è la materia preferita di tuo figlio/a a scuola?",
      answers: [
        "🔬 Scienza",
        "🎨 Arte e design",
        "💻 Informatica",
        "🏛️ Storia, letteratura",
        "📐 Matematica",
        "💬 Lingue straniere",
        "🤩 A loro piacciono tutte le materie",
        "🤔 Non ne sono sicuro",
      ],
    },
    3: {
      question:
        "Vorresti che tuo figlio acquisisca una competenza professionale che possa essere dimostrata e utilizzata in futuro?",
      answers: ["🎉 Si!", "❌ No"],
    },
    4: {
      question: "A cosa preferisce giocare tuo figlio/a?",
      answers: [
        "⛑ Super Mario",
        "🧊 Roblox",
        "👨 Minecraft",
        "🕷 Spider-Man",
        "🔫 Fortnite",
        "👩 Cooking mama",
        "❓ Un altro gioco",
      ],
    },
    5: {
      question:
        "Quanto è importante per te ricevere un certificato di formazione Kodland a fine corso?",
      answers: ["🎓 Significa molto", "😕 Non importa"],
    },
    6: {
      question:
        "Quali sono le cose più importanti che vuoi ottenere da questa lezione lezione introduttiva?",
      answers: [
        "🎓 Trascorrere il tempo produttivo utilizzando la tecnologia",
        "😕 Informazioni sulla nostra piattaforma di apprendimento",
        "🙌 Competenze utili per il futuro",
        "👶 Un ora insieme, imparando",
        "👍 Un'esperienza amichevole e piacevole",
        "💪 Scoprire se il ragazzo/a sia interessato/a",
      ],
    },
  },
};
